<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "4rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><path d="M30 41.21V21h-3v20.21a5.5 5.5 0 103 0z"/><path d="M36 36.51v-24a7.5 7.5 0 00-15 0v24a12.49 12.49 0 006.08 22.41 13 13 0 001.39.08A12.49 12.49 0 0036 36.51zm-1.17 17.07a9.41 9.41 0 01-7.42 2.36 9.5 9.5 0 01-4.09-17.4l.68-.44V12.5a4.5 4.5 0 019 0v25.6l.68.44a9.49 9.49 0 011.15 15zM44.5 13h9a1.5 1.5 0 000-3h-9a1.5 1.5 0 000 3zM53.5 19.5h-9a1.5 1.5 0 000 3h9a1.5 1.5 0 000-3zM53.5 29h-9a1.5 1.5 0 000 3h9a1.5 1.5 0 000-3z"/></svg>